const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const msalConfig = {
  auth: {
    clientId: "ad9e974e-0c27-4e8e-8444-f6895f26809d",
    authority: "https://login.microsoftonline.com/3bca970c-e63d-4ee7-a88d-e881f21cc1d3",
    redirectUri: "/",
    postLogoutRedirectUri: "/"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox
  }
};

export const loginRequest = {
  scopes: ["api://bc51f172-76d1-4b35-81ad-2baec5e9e9b2/default"]
};